import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { UserService } from 'src/app/data-services/user.service';
import { MessageService } from 'src/app/data-services/message.service';
import { PostService } from 'src/app/data-services/post.service';
import { first } from 'rxjs/operators';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  token: string;
  currentUser: any;
  userData: any = [];
  language = '';
  direction = '';
  defaultLanguage;
  Clubnews:any;
  posts2 : any;
  comments:any;
  comnew:any;
  selectNews: any = {};
  slider: any = {};
  
  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private messageService: MessageService,
    private postService : PostService,
  ) {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.messageService.selectedLanguage.subscribe(res => {
      console.log(res);
      this.language = res.lang;
      this.direction = res.dir;
    });
  }

  ngOnInit(): void {
    this.defaultLanguage = JSON.parse(localStorage.getItem('language'));
    this.direction = this.defaultLanguage.dir;
    this.language = this.defaultLanguage.lang;
    console.log(this.direction);
    this.getalliffhspost();
    this.getProfile();
    this.getNewsAll();
    
    
  }


  getProfile() {
    const data = {
      id: this.currentUser.success.user.id,
      role: this.currentUser.success.user.role,
    };
    this.userService.getProfile(data).subscribe((res: any) => {
      this.userData = res;
      this.messageService.sendMessage(this.userData);
      localStorage.setItem('userData', JSON.stringify(this.userData));

    });
  }

  getNewsAll(){
    this.postService.getNewsAll().pipe().subscribe((res: any) => {
      this.Clubnews = res;
      console.log(this.Clubnews);
  });
  }
  openModal(modal: any, _new: any) {
    this.selectNews = _new;
    modal.show();
  }
  closeModal(modal: any) {
    modal.hide();
  }
  onClick(_new) {
    this.slider = _new;
  }
  getalliffhspost(){
    this.postService.getIffhsPosts2().subscribe(post =>
      {
        this.posts2 =post;
      });
  }
  calculateDiff(sentDate) {
    var date1:any = new Date(sentDate);
    var date2:any = new Date();
    var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24 * 30 * 12));
    if(diffDays == 0)
    {
      var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24 * 30));
      if(diffDays == 0)
      {
        var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24 ));
        if(diffDays == 0)
        {
          var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60));
          if(diffDays == 0)
          {
            var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 ));
            if(diffDays == 0)
            {
              
            }
            else
            {
              return diffDays +" minutes ago";
            }
          }
          else
          {
            return diffDays +" hours ago";
          }
        }
        else
        {
          return diffDays +" day ago";
        }
      }
      return diffDays +" month ago";
    }
    else
    {
      return diffDays +" year ago";
    }
  }
  getformat(sentnumber){
    if(sentnumber == 0) {
    return 0;
    }
    else
    {        
      // hundreds
      if(sentnumber <= 999){
        return sentnumber ;
      }
      // thousands
      else if(sentnumber >= 1000 && sentnumber <= 999999){
        return (sentnumber / 1000).toFixed(2) + ' K';
      }
      // millions
      else if(sentnumber >= 1000000 && sentnumber <= 999999999){
        return (sentnumber / 1000000).toFixed(3) +' M';
      }
      // billions
      else if(sentnumber >= 1000000000 && sentnumber <= 999999999999){
        return (sentnumber / 1000000000).toFixed(3) + ' B';
      }
      else
        return sentnumber ;
      }
}
} 
